// src/utils/exportPatients.js
//
// Requires the free 'xlsx' package:
//   npm install xlsx
//
// Usage (e.g. in PatientList.js):
//   import { exportPatientsToExcel } from '../utils/exportPatients';
//   <button onClick={() => exportPatientsToExcel(patients)}>Export to Excel</button>

import * as XLSX from 'xlsx';

export function exportPatientsToExcel(patients) {
  if (!patients || patients.length === 0) {
    alert('No patients to export.');
    return;
  }

  // --- Sheet 1: Patient summary ---
  const patientRows = patients.map((p) => ({
    'MRN': p.mrn || '',
    'Name': p.name || '',
    'Phone': p.phone || '',
    'Email': p.email || '',
    'Total Vaccines': p.vaccines?.length || 0,
    'Completed Doses': p.vaccines?.filter((v) => v.status === 'completed').length || 0,
    'Pending Doses': p.vaccines?.filter((v) => v.status === 'pending').length || 0,
  }));

  // --- Sheet 2: Every vaccine record, one row each (better for audits/reports) ---
  const vaccineRows = [];
  patients.forEach((p) => {
    (p.vaccines || []).forEach((v) => {
      vaccineRows.push({
        'MRN': p.mrn || '',
        'Patient Name': p.name || '',
        'Vaccine': v.name || '',
        'Dose': v.dose || '',
        'Date': v.date ? new Date(v.date).toLocaleDateString() : '',
        'Status': v.status || '',
      });
    });
  });

  const workbook = XLSX.utils.book_new();

  const patientSheet = XLSX.utils.json_to_sheet(patientRows);
  patientSheet['!cols'] = [
    { wch: 14 }, { wch: 22 }, { wch: 16 }, { wch: 26 }, { wch: 14 }, { wch: 16 }, { wch: 14 },
  ];
  XLSX.utils.book_append_sheet(workbook, patientSheet, 'Patients');

  const vaccineSheet = XLSX.utils.json_to_sheet(vaccineRows);
  vaccineSheet['!cols'] = [
    { wch: 14 }, { wch: 22 }, { wch: 18 }, { wch: 10 }, { wch: 14 }, { wch: 12 },
  ];
  XLSX.utils.book_append_sheet(workbook, vaccineSheet, 'Vaccination Records');

  const dateStamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `vaccine-tracker-export-${dateStamp}.xlsx`);
}